import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { getApiBase } from '../utils/apiBase';
import { t } from '../locales';

const API_URL = getApiBase() + '/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;
    setSubmitting(true);
    try {
      await axios.post(
        `${API_URL}/auth/forgot-password`,
        { email: email.trim().toLowerCase() },
        { withCredentials: true }
      );
      toast.success(t('auth.forgot.toastSent'));
    } catch (error) {
      console.error('[auth/forgot-password] error payload:', error?.response?.data);
      const msg = error.response?.data?.detail || t('auth.forgot.requestFailedFallback');
      toast.error(Array.isArray(msg) ? msg.join(', ') : msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 py-8"
      style={{ background: 'radial-gradient(circle at center, #2d1b4e 0%, #050505 70%)' }}
    >
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-[min(100%,22rem)]">
        <div className="glass-effect rounded-2xl p-6 sm:p-7 border border-white/5 shadow-xl shadow-black/40">
          <div className="text-center mb-6">
            <p
              className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-2"
              style={{ fontFamily: 'Cinzel, serif' }}
            >
              {t('common.brand')}
            </p>
            <h1
              className="text-2xl sm:text-[1.65rem] font-bold text-white leading-tight"
              style={{ fontFamily: 'Cinzel, serif' }}
            >
              {t('auth.forgot.subtitle')}
            </h1>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-gray-300">
                {t('common.email')}
              </Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1 h-11 bg-black/50 border-white/20 text-white"
                placeholder={t('auth.login.placeholderEmail')}
                data-testid="forgot-password-email"
              />
            </div>
            <Button
              type="submit"
              disabled={submitting}
              className="w-full btn-primary"
              data-testid="forgot-password-submit"
            >
              {submitting ? t('auth.forgot.submitLoading') : t('auth.forgot.submit')}
            </Button>
          </form>

          <p className="text-center mt-6 text-sm text-gray-400">
            <Link to="/login" className="text-violet-400 hover:text-violet-300 font-semibold">
              {t('auth.forgot.backToLogin')}
            </Link>
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default ForgotPassword;
